import { render } from "./NavigationBar.vue?vue&type=template&id=bea23d06&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=bea23d06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bea23d06"

export default script